// 声明全局变量
export default {
  loadingAll: false, // 全局加载
  systemKeyboard: true, // 手机键盘状态
  systemFun: {}, // 系统功能
  co_type: 0 // 公司类型  0:默认类型 1：BL300 公众号类型
}



// WEBPACK FOOTER //
// ./src/common/dynamic.js